import {
	SET_DEALER_DATA,
	SET_OPTIN_DATA,
	SET_STORIES_DATA,
	ADD_STORIES_DATA
} from './types';

export function setStories(stories) {
	return {
		type: SET_STORIES_DATA,
		payload: stories
	};
}

export function addStories(stories) {
	return {
		type: ADD_STORIES_DATA,
		payload: stories
	};
}

export const setOptIns = (optIns) => {
	return {
		type: SET_OPTIN_DATA,
		payload: optIns
	};
};

export const setDealerData = (dealerData) => {
	return {
		type: SET_DEALER_DATA,
		payload: dealerData
	};
};
